
import { getMinElement, shuffle } from "@/libs/util";

function Scheduler() {
  this.scores = {};
  this.responseCounts = {};
  this.responses = [];
  this.items = [];
  this.studyMode = 'learning';
  return this;
}

Scheduler.prototype.setItems = function (items) {
  this.items = items;
  this.scores = {};
  // for (var i = 0; i < this.items.length; i++) {
  //   this.scores[i] = 0;
  //   this.responseCounts[i] = 0;
  // }
  for (let item of items) {
    var id = item.id;
    this.scores[id] = 0;
    this.responseCounts[id] = 0;
  }
};

Scheduler.prototype.addResponse = function (response) {
  this.responses.push(response);
  if (response.success) {
    this.scores[response.itemId] += 1;
  }
  this.responseCounts[response.itemId] += 1;
};

Scheduler.prototype.isSessionCompleted = function () {
  let minCount;
  if (this.studyMode == 'learning') {
    minCount = 3;
  } else {
    minCount = 2;
  }
  console.log("RESPONSE COUNTS:", this.responseCounts);
  for (let count of Object.values(this.responseCounts)) {
    if (count < minCount) {
      return false;
    }
  }
  return true;
}

Scheduler.prototype.getNextItemIndex = function () {
  if (this.isSessionCompleted()) {
    return null;
  }

  var recencyMin = 3;
  if (this.items.length <= recencyMin) {
    throw new Error(
      `Item list is only ${
      this.items.length
      } items in length -- must be at least ${recencyMin + 1} items before studying.`
    );
  }

  var nextItem = null;
  var items = shuffle(Object.keys(this.scores));

  var i = 0;
  while (nextItem === null || this.getStudyRecency(nextItem) < recencyMin) {
    nextItem = getMinElement(items, this.scores);
    console.log("CONSIDERING NEXT ITEM...", nextItem, "STUDY RECENCY:", this.getStudyRecency(nextItem));
    items.splice(items.indexOf(nextItem), 1);

    i++;
    if (i > this.items.length) {
      throw new Error(`Exceeded max loop size.`);
    }
  }

  // return nextItem;
  return this.items.map(item => item.id).indexOf(nextItem);

  // var idealItems = getMinIndices(this.scores);
  //
  // var nextItem = null;
  // var i = 0;
  // while (nextItem === null || (this.getStudyRecency(nextItem) < recencyMin)) {
  //   console.log(idealItems);
  //   nextItem = idealItems.splice(Math.floor(Math.random() * idealItems.length), 1);
  //
  //   i++;
  //   if (i > this.items.length) {
  //     throw new Error(`Exceeded max loop size.`);
  //   }
  // }
  // return nextItem;
};

Scheduler.prototype.getStudyRecency = function (itemId) {
  // for (var i=this.responses.length-1; i>-1; i--) {
  for (var i = 1; i <= this.responses.length; i++) {
    if (this.responses[this.responses.length - i].itemId === itemId) {
      return i - 1;
    }
  }
  return Infinity;
};

Scheduler.prototype.getStudySessionResults = function () {
  var results = {};

  console.log("\n\n-----------------------\nGETTING STUDY SESSION RESULTS\n\n");

  for (let item of this.items) {
    console.log("ITEM:", item);
    var id = item.id;
    results[id] = {
      itemId: id,
      score: this.scores[id] / this.responseCounts[id],
    }
  }
  return results;
}

export default Scheduler;